const de = {
  title: 'leihBar',
  addToCart: 'In Warenkorb legen',
  selectProduct: 'Angebot auswählen',
  lender: 'Entleiher',
  internalNote: 'interner Produktvermerk',
  internalArticleNote: 'interner Artikelvermerk',
  tabs: {
    products: 'Angebote',
    categories: 'Kategorien',
    locations: 'Standorte',
    bundles: 'Bundles',
    orders: 'Bestellhistorie'
  },
  profile: {
    title: 'leihBar Profil',
    tabs: {
      mailtemplates: 'Mail Vorlagen',
      vacation: 'Urlaub',
      openingHours: 'Öffnungszeiten'
    },
    selectEntitlementGroup:
      'Sie sind mehr als einem Bereich zugeordnet. Bitte wählen Sie den Bereich aus, den Sie bearbeiten möchten:'
  },
  tooltips: {
    shareButton: 'Kopiert den Link zu diesem Produkt in die Zwischenablage',
    myOffers: 'Zeigt nur Ihre Angebote an, bzw. die welche Sie bearbeiten dürfen',
    bookingCanceled: 'Die Buchung wurde storniert',
    endTimeOverdue: 'Das Abgabedatum der Buchung liegt in der Vergangenheit'
  },
  category: {
    create: {
      name: 'Kategoriename',
      icon: 'Icon',
      createModalTitle: 'Kategorie anlegen',
      editModalTitle: 'Kategorie bearbeiten'
    },
    columns: { name: 'Kategoriename', icon: 'Icon' },
    dialogs: {
      deleteConfirm: {
        title: 'Wirklich löschen?',
        message: 'Wollen Sie wirklich die Kategorie löschen?'
      }
    },
    alerts: {
      successfulCreate: 'Die Kategorie wurde angelegt.',
      successfulUpdate: 'Die Kategorie wurde bearbeitet.',
      successfulDelete: 'Die Kategorie wurde gelöscht.',
      failedCreate: 'Die Kategorie konnte nicht angelegt werden.',
      failedUpdate: 'Die Kategorie konnte nicht bearbeitet werden.',
      failedDelete: 'Die Kategorie konnte nicht gelöscht werden.',
      failedImageUpload: 'Das Bild konnte nicht hochgeladen werden.',
      errorLoading: 'Die Kategorie konnte nicht geladen werden.'
    }
  },
  location: {
    create: {
      name: 'Standort',
      createModalTitle: 'Standort anlegen',
      editModalTitle: 'Standort bearbeiten'
    },
    columns: { name: 'Standort' },
    dialogs: {
      deleteConfirm: {
        title: 'Wirklich löschen?',
        message: 'Wollen Sie wirklich den Standort löschen?'
      }
    },
    alerts: {
      successfulCreate: 'Der Standort wurde angelegt.',
      successfulUpdate: 'Der Standort wurde bearbeitet.',
      successfulDelete: 'Der Standort wurde gelöscht.',
      failedCreate: 'Der Standort konnte nicht angelegt werden.',
      failedUpdate: 'Der Standort konnte nicht bearbeitet werden.',
      failedDelete: 'Der Standort konnte nicht gelöscht werden.',
      errorLoading: 'Der Standort konnte nicht geladen werden.'
    }
  },
  product: {
    location: 'Standort',
    name: 'Angebot',
    description: 'Beschreibung',
    categories: 'Kategorien',
    domain: 'Bereich',
    hint: 'Hinweis',
    availability: {
      header: 'Verfügbarkeit',
      partiallyAvailableDescription: 'Teilweise verfügbar',
      availableDescription: 'Ganzer Tag verfügbar'
    },
    noMaxBooking: 'Keine Buchungsdauer angegeben',
    noPreparationTime: 'Keine Rüstzeit angegeben',
    contact: 'Kontakt',
    recurringInterval: 'Jeden {{weekday}} von {{start}} bis {{end}}',
    filter: {
      myOffers: 'Meine Angebote'
    },
    bundle: {
      content: 'Bundle Inhalt',
      noProductsSelected: 'Bisher keine Produkte ausgewählt',
      noProductsAvailable:
        'Keine Produkte mit diesem Namen verfügbar. Bitte überprüfen Sie Ihre Eingabe im Suchfeld.',
      navigateToProduct: 'Gehe zu Produkt'
    },
    create: {
      createHeading: 'Neues Angebot',
      editHeading: 'Angebot bearbeiten',
      bundleHeading: 'Produkte zu Bundle hinzufügen',
      productname: 'Produktname',
      image: 'Produktbild',
      description: 'Beschreibung',
      type: 'Angebotstyp',
      bundleProducts: 'Enthaltene Produkte',
      category: 'Kategorie',
      domain: 'Bereich',
      location: 'Standort',
      editorGroupId: 'Emails der weiteren Bearbeiter',
      bookingCriteria: 'Zielgruppe',
      targetUsers: 'Zielbenutzer',
      availability: 'Verfügbarkeit',
      pickUpAndReturnTimes: 'Verleiherverfügbarkeiten',
      alwaysAvailable: 'Immer verfügbar',
      independentOfLenderTimes: 'Unabhängig von Abhol-/Rückgabezeiten des Verleihers',
      bookingSlot: { name: 'Zeitraum', start: 'Start', end: 'Ende' },
      pickers: {
        startend: 'Start-End-Auswahl',
        recurringInterval: 'Wiederkehrender Zeitraum'
      },
      maxBooking: 'Maximale Buchungsdauer',
      maxPreBooking: 'Maximale Vorbuchungsdauer',
      preparationTime: 'Rüstzeit',
      reactionTime: 'Reaktionszeit',
      maxArticleAmount: 'Maximale Menge',
      amountPossible: 'Mengenangabe möglich?',
      lender: { email: 'Kontakt-Email', number: 'Kontaktnummer' },
      bookingMailActive: 'Email-Benachrichtigung erhalten bei Buchung',
      hint: 'Organisatorischer Hinweis',
      units: { MINUTE: 'Minuten', HOUR: 'Stunden', DAY: 'Tage', WEEK: 'Wochen', MONTH: 'Monate' },
      types: { BASIC: 'Produkt', BUNDLE: 'Bundle' },
      steps: {
        generalInformation: {
          title: 'Allgemeine Informationen',
          text: 'Diese Information hilft das Produkt zu identifizieren'
        },
        description: {
          title: 'Beschreibung',
          text: 'Ausführliche Beschreibung des Produktes'
        },
        type: {
          title: 'Art des Angebot',
          text: 'Um was für eine Art Produkt handelt es sich?'
        },
        bundleProducts: {
          title: 'Produkte im Bundle',
          text: 'Welche Produkte sollen im Bundle enthalten sein?'
        },
        category: {
          title: 'Kategorie des Produkts',
          text: 'Welcher Kategorie ist das Produkt zuzuordnen?'
        },
        domainAndLocation: {
          title: 'Bereich und Standort',
          text: 'Welchem Bereich wird dieses Produkt zugewiesen und wo befindet es sich?',
          editInfo: 'Bei Speichern des Angebots wird der neue Bereich "{{domain}}" angelegt'
        },
        editorGroup: {
          title: 'Weitere Bearbeiter',
          text: 'Wer darf außer dem Verleiher noch dieses Produkt bearbeiten?'
        },
        bookingCriteria: {
          title: 'Zielgruppe',
          text: 'Welche Zielgruppe darf dieses Produkt buchen?\nAndere Zielgruppen sehen das Objekt nicht.'
        },
        bookingSlots: {
          title: 'Verfügbare Zeiträume',
          text: 'Geben Sie an wann dieses Angebot verfügbar ist.'
        },
        intervals: {
          title: 'Maximale Buchungsdauer und Rüstzeit',
          text: 'Wie lange darf das Produkt maximal gebucht werden und wie lange wird benötigt zwischen Rückgabe und nächster möglicher Buchung?',
          editInfo:
            'Bereits bestehende Buchungen sind von einer Änderung der Rüstzeit nicht betroffen.',
          maxPrebookingInfo:
            'Das ist die maximale Zeit, die ein Produkt im voraus gebucht werden kann.',
          preparationTimeInfo:
            'Die Rüstzeit ist die Zeit, die zwischen Rückgabe und erneuerter Ausgabe benötigt wird, um den Artikel erneut ausgabefähig vorzubereiten.',
          reactionTimeInfo:
            'Die Reaktionszeit ist die Zeit, die zwischen Buchung und Abholung benötigt wird, um den Artikel für die Ausgabe vorzubereiten.',
          isIndependentOfLenderTimes:
            'Wenn dieser Schalter aktiviert ist, kann das Produkt unabhängig von den angegebenen Abhol-/ und Rückgabezeiten des Verleihers gebucht werden'
        },
        amount: {
          title: 'Artikelmenge',
          text: 'Kann das Produkt mehrfach ausgeliehen werden? Wie oft kann es maximal ausgeliehen werden?',
          maxAmountInfo:
            'Das ist die maximale Menge an Artikel, die ein Entleiher gleichzeitig entleihen darf.'
        },
        lender: {
          title: 'Informationen zum Verleiher',
          text: 'Über diese Informationen können Interessenten Kontakt zum Verleiher aufnehmen'
        },
        internalNote: {
          title: 'Interner Produktvermerk vom Verleiher',
          text: 'Erscheint nur auf der Produktübersicht für den Verleiher'
        },
        more: {
          title: 'Weitere Vermerke',
          text: 'Weitere optionale Hinweise und Vermerke'
        }
      },
      placeholder: {
        uploadImage: 'Bild hochladen',
        hint: "z.B. 'Buchung nach tel. Vereinbarung' oder 'Bitte vor Rückgabe bei Herr ... melden'",
        internalNote: "z.B. 'Produkt benötigt Zugangscode'",
        enterEmail: 'Kontakt-Email',
        enterNumber: 'z.B. +49 123 123123'
      }
    },
    tooltips: {
      editors: 'Dieses Feld sehen nur Personen mit Bearbeitungsrechten für dieses Angebot',
      lenderGroupIdDisabled:
        'Der Bereich eines Produktes kann nicht geändert werden. Bitte klonen Sie das Produkt um die Verleihergruppe zu ändern.'
    },
    tabs: {
      product: 'Angebot',
      articles: 'Artikel',
      bookings: 'Buchungen'
    },
    dialogs: {
      deleteConfirm: {
        title: 'Wirklich löschen?',
        message: 'Wollen Sie wirklich das Angebot löschen?'
      },
      cloneConfirm: {
        title: 'Wirklich klonen?',
        message: 'Möchten Sie das Angebot wirklich klonen?'
      }
    },
    alerts: {
      error: {
        getProducts: 'Die Produkte konnten nicht geladen werden',
        getAvailabilities:
          'Die Verfügbarkeiten konnten nicht geladen werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
        notFound: 'Das Produkt konnte nicht gefunden werden',
        openFailed: 'Das Produkt konnte nicht geöffnet werden',
        openCreateFailed: 'Ein Fehler ist aufgetreten beim Laden der Seite.'
      },
      successfulCreate: 'Das Produkt wurde erstellt',
      successfulUpdate: 'Das Produkt wurde aktualisiert',
      successfulDelete: 'Das Angebot wurde gelöscht',
      successfulClone: 'Das Angebot wurde geklont',
      failedCreate: 'Das Produkt konnte nicht erstellt werden',
      failedUpdate: 'Das Produkt konnte nicht aktualisiert werden',
      failedDelete: 'Das Angebot konnte nicht gelöscht werden',
      failedClone: 'Das Angebot konnte nicht geklont werden',
      failedImageUpload: 'Das Bild konnte nicht hochgeladen werden.'
    },
    detailPage: {
      options: 'Zubuchbare Optionen',
      selectOption: 'Option auswählen'
    },
    showArticles: 'Zeige verfügbare Artikel'
  },
  booking: {
    editModalTitle: 'Buchung bearbeiten',
    noRows: 'Bisher noch keine Buchungen dieses Angebots.',
    columns: {
      userId: 'Ausleiher',
      start: 'Abholung',
      end: 'Rückgabe'
    },
    validation: {
      conflictBookings: 'Es gibt Konflikte mit anderen Buchungen'
    },
    alerts: {
      successfulUpdate: 'Die Buchung wurde bearbeitet.',
      successfulCancel: 'Die Buchung wurde storniert.',
      failedUpdate: 'Die Buchung konnte nicht bearbeitet werden.',
      failedCancel: 'Die Buchung konnte nicht storniert werden.'
    },
    dialogs: {
      deleteConfirm: {
        title: 'Wirklich stornieren?',
        message: 'Wollen Sie wirklich die Buchung stornieren?'
      }
    },
    warnings: {
      availableArticle: {
        title: 'Verfügbare Artikel',
        messagePart1:
          'Hier sehen Sie alle Artikelnummern zu diesem Produkt. Erscheint ein Warnsymbol hinter einer Artikelnummer, so kann diese nicht ausgetauscht werden, da ein Konflikt mit einer anderen Buchung besteht. Wählen Sie diese trotzdem aus, so werden Ihnen die Konfliktbuchungen angezeigt. Das System blockiert jedoch dann Speicherung mit einer bereits vergebenen Artikelnummer.',
        messagePart2:
          'Falls notwendig können Sie manuell (beispielsweise durch Stornierung oder Änderung der Abholung-/Rückgabezeitraum) den Konflikt auflösen und dann erneut versuchen die Artikelnummer auszutauschen. Das Warnsymbol verschwindet dann.',
        messagePart3:
          'Bitte beachten Sie, dass die zwischenzeitliche Änderung der Rüstzeit eine Auswirkung auf das Bearbeiten von Buchungen haben kann.'
      }
    },
    tooltips: {
      skuDisabled:
        'Eine Änderung der Artikelnummer ist nicht möglich da die Buchung bereits abgeholt wurde.'
    }
  },
  option: {
    noOptions: 'Noch keine Optionen verfügbar',
    create: {
      heading: 'Neue Option',
      title: 'Titel',
      description: 'Beschreibung',
      image: 'Optionsbild',
      count: 'Anzahl',
      createModalTitle: 'Option erstellen',
      editModalTitle: 'Option bearbeiten'
    },
    alerts: {
      successfulCreate: 'Die Option wurde erstellt',
      successfulUpdate: 'Die Option wurde aktualisiert',
      successfulDelete: 'Die Option wurde gelöscht',
      failedCreate: 'Die Option konnte nicht erstellt werden',
      failedUpdate: 'Die Option konnte nicht aktualisiert werden',
      failedDelete: 'Die Option konnte nicht gelöscht werden',
      failedImageUpload: 'Das Bild konnte nicht hochgeladen werden.'
    },
    dialogs: {
      deleteConfirm: {
        title: 'Wirklich löschen?',
        message: 'Wollen Sie wirklich diese Option löschen?'
      }
    }
  },
  article: {
    name: 'Artikel',
    columns: {
      articleId: 'Artikelnummer',
      visibility: 'Sichtbarkeit'
    },
    create: {
      createHeading: 'Neuer Artikel',
      editHeading: 'Artikel bearbeiten',
      articleId: 'Artikelnummer',
      isVisible: 'Sichtbarkeit',
      steps: {
        articleId: {
          title: 'Eindeutige Artikelnummer',
          text: 'Geben Sie hier die eindeutige Artikelnummer des anzubietenden Produktes ein.'
        },
        isVisible: {
          title: 'Sichtbarkeit',
          text: 'Stellen Sie ein ob der Artikel sichtbar sein soll.',
          editInfo:
            'Bereits bestehende Buchungen sind von einer Änderung der Sichtbarkeit nicht betroffen.'
        },
        internalNote: {
          title: 'Interner Vermerk vom Verleiher',
          text: 'Erscheint nur in der Artikelübersicht für den Verleiher'
        }
      }
    },
    dialogs: {
      deleteConfirm: {
        title: 'Wirklich löschen?',
        message: 'Wollen Sie wirklich diesen Artikel löschen?'
      }
    },
    alerts: {
      successfulCreate: 'Der Artikel wurde erstellt',
      successfulUpdate: 'Der Artikel wurde aktualisiert',
      successfulDelete: 'Der Artikel wurde gelöscht',
      failedCreate: 'Der Artikel konnte nicht erstellt werden',
      failedUpdate: 'Der Artikel konnte nicht aktualisiert werden',
      failedDelete: 'Der Artikel konnte nicht gelöscht werden'
    }
  },
  orders: {
    heading: 'Bestellung von {{customerName}}',
    tabs: {
      overview: 'Bestellübersicht',
      picking: 'Kommissionierliste',
      pickup: 'Abholung',
      return: 'Rückgabe'
    },
    columns: {
      articleCount: 'Artikelanzahl',
      pickupDate: 'Abholzeitpunkt',
      returnDate: 'Rückgabezeitpunkt'
    },
    articleInOrder: 'Artikel in der Bestellung',
    pickup: {
      columns: {
        articleNumber: 'Artikelnummer',
        articleName: 'Artikelname',
        internalNote: 'Artikelvermerk',
        plannedPickup: 'Gebuchter Abholzeitpunkt',
        collectedAt: 'Abholzeitpunkt',
        plannedReturn: 'Gebuchter Rückgabezeitpunkt',
        returnedAt: 'Rückgabezeitpunkt',
        commentByBorrower: 'Bemerkung Entleiher'
      }
    },
    orderNumber: 'Bestellnummer',
    orderDate: 'Bestelldatum',
    cancelOrder: 'Bestellung stornieren',
    dialogs: {
      cancelOrder: {
        title: 'Wirklich stornieren?',
        message: 'Wollen Sie wirklich die Bestellung stornieren?'
      }
    }
  },
  shoppingCart: {
    title: 'Warenkorb',
    empty: 'Dein Warenkorb ist leer',
    products: 'Produkte',
    options: 'Optionen',
    orderNow: 'Jetzt bestellen',
    steps: {
      availability: 'Zeitraum',
      options: 'Zubuchbare Optionen'
    },
    modalTitle: 'Produktkonfiguration',
    modalInfoTitleMaxBooking: 'Maximale Buchungsdauer',
    modalInfoTextMaxBooking: 'Dieses Produkt hat eine maximale Buchungsdauer von {{maxBooking}}.',
    modalInfoTextMaxBookingWithMaxPrebooking:
      'Dieses Produkt hat eine maximale Buchungsdauer von {{maxBooking}} und kann maximal bis zu {{maxPreBooking}} Tage im voraus gebucht werden.',
    modalInfoTitleAvailabilityTime: 'Abholung und Rückgabe',
    modalInfoTextAvailabilityTime:
      'Zur Abholung und Entgegennahme bei Rückgabe ist nur zu den folgenden Zeiten jemand verfügbar: ',
    modalInfoTextNotice: 'Bitte beachten Sie die Infos zu Buchungsdauer und Abholung/Rückgabe',
    noOptions: 'Für dieses Angebot gibt es keine zubuchbaren Optionen',
    bookingDay: 'Buchungstag',
    notAvailable: 'Dieses Angebot ist aktuell leider nicht verfügbar',
    articleNotAvailable: 'Artikel nicht mehr verfügbar',
    pickUpTime: 'Abholung',
    returnTime: 'Rückgabe',
    availableArticle: 'Verfügbare Artikel',
    amount: 'Anzahl',
    comment: 'Bemerkung',
    bundleContent: 'Bundle-Inhalt',
    alerts: {
      successfulCreate: 'Zu Warenkorb hinzugefügt',
      successfulUpdate: 'Warenkorb wurde aktualisiert',
      failedCreate: 'Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten',
      failedUpdate: 'Beim Aktualisieren des Warenkorbs ist ein Fehler aufgetreten',
      successfulOrder: 'Bestellung wurde durchgeführt',
      failedOrder: 'Bei der Bestellung ist ein Fehler aufgetreten',
      noArticleAvailable:
        'Das Angebot mit der ID {{productId}} ist im gewünschten Zeitraum nicht verfügbar'
    },
    placeholder: { comment: "z.B. 'Bitte Herrn Huber aushändigen'" },
    tooltips: {
      goToProduct: 'Gehe zu Angebot'
    }
  },
  daily: {
    title: 'Tagesansicht',
    today: 'Heute',
    selectDay: 'Tag auswählen',
    overdue: 'Überfällig',
    conflicting: 'Konflikt bevorstehend',
    noBookings: 'Keine Buchungen',
    lenderGroup: 'Bereich',
    buttonLabels: {
      approvePicking: 'Kommisionierung bestätigen',
      approveCollection: 'Abholung bestätigen',
      approveReturn: 'Rückgabe bestätigen'
    },
    colorLegend: 'Legende',
    tooltips: {
      disabledEdit: {
        returned: 'Bearbeiten nicht möglich, da der Artikel bereits zurückgegeben wurde',
        notLender: 'Bearbeiten nicht möglich, da Sie nicht der Verleiher des Artikels sind'
      },
      disabledCancel: {
        collected: 'Stornieren nicht möglich, da der Artikel bereits abgeholt wurde',
        notLender: 'Stornieren nicht möglich, da Sie nicht der Verleiher des Artikels sind'
      }
    },
    alerts: {
      overdue:
        'In dieser Bestellung befindet sich mindestens ein Artikel, der entweder zur Abholung oder Rückgabe bereits überfällig ist. Bitte kontaktieren Sie den Ausleihenden.',
      conflicting:
        'In dieser Bestellung befindet sich mindestens ein Artikel, der überfällig ist und bereits in einer Bestellung gebucht wurde. Bitte kontaktieren Sie den Ausleihenden.',
      conflictingOrderList: 'Folgende Bestellungen sind betroffen: '
    },
    tabs: {
      pickups: 'Abholungen',
      returns: 'Rückgaben'
    }
  },
  statistics: {
    title: 'Statistik'
  },
  access: {
    title: 'Zugriffsrechte',
    columns: {
      lenderGroup: 'Verleihergruppe',
      entitlements: 'Entitlements'
    },
    alerts: {
      deleteSuccess: 'Gruppe erfolgreich gelöscht',
      deleteFailed: 'Gruppe konnte nicht gelöscht werden',
      createSuccess: 'Gruppe erfolgreich erstellt',
      createFailed: 'Gruppe konnte nicht erstellt werden',
      updateSuccess: 'Gruppe erfolgreich bearbeitet',
      updateFailed: 'Gruppe konnte nicht bearbeitet werden'
    }
  },
  terms: {
    title: 'Nutzungsbedingungen',
    text1:
      'Hiermit stimmen Sie den Nutzungsbedingen der leihBar der Technischen Hochschule Rosenheim zu und verpflichten sich, die in der leihBar verfügbaren Angebote ausschließlich im Hochschulkontext zu nutzen und pfleglich zu behandeln.',
    text2: 'Die vollständige Version der',
    text3: 'Nutzungsbedingungen finden sie hier.'
  }
};

export default de;
export type LeihBarTranslation = typeof de;
